
type fetcherArgsType = [input: RequestInfo, init?: RequestInit]
const fetcher = (...args: fetcherArgsType) => fetch(...args).then(res => res.json());

export default fetcher